import {
	Edit,
	SimpleForm,
	useRefresh,
	TextInput,
	useNotify,
	useRedirect,
	useTranslate,
	SelectInput,
	NumberInput,
} from "react-admin";
import { validateProductData } from "./productValidate";
import { CustomToolbar } from "../../customComponents/CustomToolbar";
import { getAllCurrencies } from "../../utils/helpers";

export const ProductEdit = (props) => {
	const redirect = useRedirect();
	const refresh = useRefresh();
	const translate = useTranslate();
	const notify = useNotify();
	const currencies = getAllCurrencies();

	const onSuccess = () => {
		notify("web-products.edit.success", "info");
		redirect("/web-products");
		refresh();
	};

	const onFailure = (error) => {
		notify(error.message, "warning");
	};

	return (
		<Edit
			{...props}
			title={translate("web-products.edit.title")}
			onSuccess={onSuccess}
			onFailure={onFailure}
			mutationMode="pessimistic"
		>
			<SimpleForm
				toolbar={<CustomToolbar />}
				validate={validateProductData}
				syncWithLocation={false}
			>
				<TextInput source="name" />
				<NumberInput source="price" />
				<SelectInput
					source="currency"
					choices={currencies}
					defaultValue="SAR"
					optionText={({ code }) => code}
					optionValue="code"
				/>
			</SimpleForm>
		</Edit>
	);
};
